import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconConsoleSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"console-simple"} maskId="square-filled-radius-0-stroke-1-IconConsoleSimple"><path fillRule="evenodd" clipRule="evenodd" d="M4.50008 5.79291L10.7072 12L4.50008 18.2071L3.79297 17.5L9.29297 12L3.79297 6.50001L4.50008 5.79291ZM12.0001 17H20.0001V18H12.0001V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconConsoleSimple;
